// extracted by mini-css-extract-plugin
export default {"myJobHeader":"OrderListing_myJobHeader__GbtzE"};